import React from 'react';
import { Button, Stack, TextInput } from '@mantine/core';
import CollapsibleListField from '../../../puck/fields/CollapsibleListField';
import { useSelectedItemProps } from '../../../puck/fields/useSelectedItemProps';
import { plainText } from '../../../utils/richTextHtml';
import { getMediaSrc } from '../../../media/mediaSource';
import { chapterPlayer } from './videoChapterRegistry';
import { chapterError, formatChapterTime, parseChapterTime } from './videoChapters';

export default function VideoChaptersField({ value = [], onChange }) {
  const { itemProps } = useSelectedItemProps();
  const player = () => chapterPlayer(itemProps.id, getMediaSrc(itemProps.src));
  return (
    <CollapsibleListField
      value={value}
      onChange={onChange}
      addLabel="Ajouter un chapitre"
      createItem={(count) => ({ title: `Chapitre ${count + 1}`, time: Math.floor(player()?.currentTime || 0) })}
      itemTitle={(item, index) => plainText(item.title) || `Chapitre ${index + 1}`}
      renderItem={(item, update) => (
        <Stack gap="xs">
          <TextInput
            label="Début du chapitre"
            description="Le titre se modifie directement sur la vidéo dans la page."
            value={item.timeInput ?? formatChapterTime(item.time)}
            error={chapterError(item, value, player()?.duration)}
            onChange={(event) => {
              const timeInput = event.currentTarget.value;
              update({ timeInput, time: parseChapterTime(timeInput) });
            }}
            onBlur={() => { if (Number.isFinite(item.time)) update({ timeInput: undefined }); }}
          />
          <Button size="xs" variant="default" onClick={() => {
            const position = player();
            if (position) update({ time: Math.floor(position.currentTime), timeInput: undefined });
          }}>Utiliser la position courante</Button>
        </Stack>
      )}
    />
  );
}
